import React from "react";

import RestrictedSection from "./RestrictedSection";

const MenteesOnly: React.FunctionComponent = ({ children }) => {
	return <RestrictedSection isMenteesOnly>{children}</RestrictedSection>;
};

export default MenteesOnly;
